import React, { memo, useContext, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ModalContext } from "components/ModalContext";
import { useSelector } from "react-redux";
import { useDashboardState } from "components/DashboardContext";
import { checkPremium, getFoldersBreadcrumbs } from "utils/helpers";
import { useHistory } from 'react-router-dom';
import "./Header.scss";

import LogoutModal from "components/modals/LogoutModal";
import BreabcrumbsItem from 'components/uiComponents/BreabcrumbsItem';

import bimLogoBlack from "static/images/bim_logo_black.png";
import { ReactComponent as HomeIcon } from 'static/icons/home.svg';
import SupportDropDown from "../uiComponents/DropDownSupport";

const Header = memo(() => {
  const {
    foldersTree,
    activeFolder,
    activeProject,
    setActiveFolder,
    setActiveProject,
    setIsTableHidden,
  } = useDashboardState();
  const history = useHistory();

  const [breadcrumbsData, setBreadcrumbsData] = useState({
    activeProject: null,
    foldersTree: null,
    activeFolder: null
  });

  useEffect(() => {
      const breadcrumbsData = {
        activeProject: activeProject,
        foldersTree: foldersTree,
        activeFolder: activeFolder
      };
    if((activeFolder === "recent" && !activeProject?.text) || history?.location?.pathname === "/") {
      localStorage.removeItem("breadcrumbsData")
    } else {
      localStorage.setItem("breadcrumbsData", JSON.stringify(breadcrumbsData));
      setBreadcrumbsData(breadcrumbsData);
    }
  }, [activeFolder, activeProject?.text]);



  const {
    info: { picture, name, subscreption },
  } = useSelector((state) => state.user);

  const IS_PREMIUM = checkPremium(subscreption);

  const { handleModal } = useContext(ModalContext);

  const logOut = () => {
    handleModal(<LogoutModal closeModal={handleCloseModal} />);
  };

  const handleCloseModal = () => {
    handleModal(null, true);
  };

  const breadcrumbsArr = useMemo(() => {
    if (breadcrumbsData?.activeFolder !== 'favourites' && breadcrumbsData?.activeFolder !== 'recent' && breadcrumbsData?.activeFolder) {
      const breadcrumbs = getFoldersBreadcrumbs(breadcrumbsData?.activeFolder, breadcrumbsData?.foldersTree);
      breadcrumbs?.shift();

      return breadcrumbs;
    }

    if (breadcrumbsData?.activeFolder === 'favourites') {
      return [{
        id: 'favourites',
        text: 'Favorites'
      }];
    }

    if (breadcrumbsData?.activeFolder === 'recent') {
      return [{
        id: 'recent',
        text: 'Recent'
      }];
    }
  }, [breadcrumbsData?.foldersTree, breadcrumbsData?.activeFolder]);
  const handleHomeClick = () => {
    setActiveFolder('recent');
    setActiveProject(null);
    setIsTableHidden(true);

    history.push({
      pathname: `/`,
    });
  };

  return (
    <div className="header">
      <div className="header-left">
        <Link onClick={handleHomeClick} to="/">
          <img
            src={bimLogoBlack}
            alt="Black logotype"
            className="header-left__logo"
          />
          {
            IS_PREMIUM ? <span className="header-left__logo-premium">Premium</span> : null
          }
        </Link>
      </div>

      {breadcrumbsData?.activeProject?.text && history.location.pathname !== "/" &&
      <div className="header__breadcrumbs">
        <div className="header__breadcrumbs_home">
          <div
            className="header__breadcrumbs_home-icon"
            onClick={handleHomeClick}
          >
            <HomeIcon />
          </div>

            <span
              className="header__breadcrumbs_slash"
            >
              /
            </span>
          </div>

          {breadcrumbsArr?.map((item, index) => {
            const handleBreadcrumbsItemClick = () => {
              setActiveFolder(item.id);
              setActiveProject(null);
              setIsTableHidden(true);

              history.push({
                pathname: `/`,
              });
            };

            return (
              <BreabcrumbsItem
                key={item.id}
                text={item.text}
                isFirst={index === 0}
                onClick={handleBreadcrumbsItemClick}
              />
            );
          })}

        <div className="header__breadcrumbs_project">
          {breadcrumbsData?.activeProject?.text}
        </div>
      </div>
      }

      <div className="header-right">
        <SupportDropDown/>
        <div className="drop-down drop-down-user">
          <div className="drop-down-btn header-profile">
            <img src={picture} alt="" />

            <p>{name}</p>

            <i></i>
          </div>

          <div className="drop-down-box-wrapper user-dropdown">
            <Link to="/settings">Settings</Link>

            <p className="exit-btn" onClick={logOut}>
              Log Out
            </p>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Header;
